import * as Sentry from '@sentry/browser';
import { all, call, spawn, takeLatest } from 'redux-saga/effects';
import { evictLocalizedDashboardFields } from 'components/dashboardWidgets/helpers';
import actions from 'redux/languageSwitcher/actions';
import client from 'graphql/client';
import mutateUserLocaleGraphql from './graphql';

export function* changeUserLocaleGenerator(action) {
  try {
    yield call(mutateUserLocaleGraphql, {
      variables: {
        locale: action.language.locale.toUpperCase(),
      },
    });
    yield call(() => {
      Sentry.configureScope(scope => {
        scope.setTag('locale', action.language.locale);
      });
    });
    /*
     * Only after the mutation — the backend translates the dashboard from the persisted
     * `Employer.locale` (`ChangeUserLocaleMutation`) rather than from the `locale` header,
     * so a refetch running in parallel could land before the write and come back in the
     * old language again.
     */
    yield call([client, client.refetchQueries], {
      updateCache: evictLocalizedDashboardFields,
    });
  } catch (e) {
    Sentry.captureException(e);
  }
}

function* changeUserLocale() {
  yield takeLatest(actions.CHANGE_LANGUAGE, changeUserLocaleGenerator);
}

export default function* rootSaga() {
  yield all([spawn(changeUserLocale)]);
}
